
export default function Differentiation() {
  const differentiators = [
    {
      number: "01",
      title: "Atenção Pessoal Exclusiva",
      description:
        "Acesso direto à nossa equipe dedicada, não a um call center. Relacionamentos reais, cuidado genuíno.",
    },
    {
      number: "02",
      title: "Vagas Limitadas",
      description:
        "Aceitamos apenas um número selecionado de clientes por mês para garantir qualidade excepcional.",
    },
    {
      number: "03",
      title: "Planejamento Estratégico",
      description:
        "Roteiros baseados no seu perfil, orçamento e objetivos de viagem.",
    },
    {
      number: "04",
      title: "Experiências VIP",
      description:
        "Acesso a locais exclusivos, reservas prioritárias e oportunidades únicas para poucos.",
    },
  ];

  return (
    <section className="bg-black py-24 relative overflow-hidden">
      {/* Background gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#D4AF37]/5 via-transparent to-transparent" />

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="text-center mb-20 space-y-6">
          <p className="text-[#D4AF37] text-sm uppercase tracking-[0.3em] font-semibold">
            O Diferencial PremierNY
          </p>
          <h2 className="text-3xl lg:text-4xl font-serif font-bold leading-tight">
            Você Não Precisa Apenas de uma Viagem.
            <br />
            Você Precisa de uma{" "}
            <span className="text-[#D4AF37] italic">Estratégia</span>.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {differentiators.map((item, index) => (
            <div key={index} className="relative">
              <div
                className="text-7xl font-bold text-transparent mb-6"
                style={{ WebkitTextStroke: "2px #D4AF37" }}
              >
                {item.number}
              </div>

              <h3 className="text-2xl font-bold mb-4 text-white leading-tight">
                {item.title}
              </h3>

              <p className="text-gray-400 text-base leading-relaxed">
                {item.description}
              </p>

              {/* Divider line for large screens */}
              {index < differentiators.length - 1 && (
                <div className="hidden lg:block absolute top-0 right-0 w-px h-full bg-gradient-to-b from-transparent via-[#D4AF37]/30 to-transparent" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
